import { render, staticRenderFns } from "./b-ticket-header.vue?vue&type=template&id=5c4dd048&scoped=true"
import script from "./b-ticket-header.vue?vue&type=script&lang=ts"
export * from "./b-ticket-header.vue?vue&type=script&lang=ts"
import style0 from "./b-ticket-header.vue?vue&type=style&index=0&id=5c4dd048&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4dd048",
  null
  
)

export default component.exports